import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { SettingsPage } from '@/features/settings/settings-page';
import { SETTINGS_TABS } from '@/features/settings/settings-tabs';
import { guardRoute } from '@/lib/route-guards';

/** `?tab=sign-in` opens Sign-in & email (T-137); anything else shows General. */
const searchSchema = z.object({ tab: z.enum(SETTINGS_TABS).optional().catch(undefined) });

export const Route = createFileRoute('/_app/admin/settings')({
  validateSearch: searchSchema,
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/admin/settings');
  },
  component: SettingsRoute,
});

function SettingsRoute() {
  const { tab } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <SettingsPage
      tab={tab ?? 'general'}
      onTabChange={(next) => {
        void navigate({ search: next === 'general' ? {} : { tab: next }, replace: true });
      }}
    />
  );
}
